import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';

export interface MatterByCountryData {
    statistics: Statistics;
}

export interface Statistics {
    matter: Matter;
}

export interface Matter {
    mattersByCountry: MattersByCountry;
}

export interface MattersByCountry {
    liveMatterCountries: MatterCountry[];
    deadMatterCountries: MatterCountry[];
    liveMattersCount: number;
    deadMattersCount: number;
    totalMattersCount: number;
}

export interface MatterCountry {
    country: string;
    countryTotalCount: number;
    countryStatus: CountryStatus[];
}

export interface CountryStatus {
    description: string;
    count: number;
}

export interface MatterByCountryParams {
    entityType?: number;
    entityGuid?: string;
    responsibility?: number;
    showAllRecords?: boolean;
    filter?: string;
}

const MATTER_BY_COUNTRY_QUERY = gql`
	query mattersByCountryData($entityType: Int, $entityGuid: String, $responsibility: Int, $showAllRecords: Boolean, $filter: String) {
	statistics {
		matter {
			mattersByCountry(entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility, showAllRecords: $showAllRecords, filter: $filter) {
				liveMatterCountries {
					country
					countryTotalCount
					countryStatus {
						description
						count
					}
				}
				deadMatterCountries {
					country
					countryTotalCount
					countryStatus {
						description
						count
					}
				}
				liveMattersCount
				deadMattersCount
				totalMattersCount
			}
		}
	}
}

`;

export const useMatterByCountryQuery = (params: MatterByCountryParams) => {
    const { data, error, loading } = useQuery<MatterByCountryData, MatterByCountryParams>(MATTER_BY_COUNTRY_QUERY, {
        fetchPolicy: 'network-only',
        variables: {
            entityGuid: params.entityGuid,
            entityType: params.entityType,
            responsibility: params.responsibility,
            showAllRecords: params.showAllRecords,
            filter: params.filter
        },
    });

    return {
        data,
        error,
        loading,
    };
};
